import { useEffect } from "react";
import { MapContainer, TileLayer, Marker, useMap, useMapEvents } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";

const pinIcon = L.divIcon({
  className: "pp-pin",
  html: `<svg width="34" height="34" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 22s7-6.5 7-12A7 7 0 0 0 5 10c0 5.5 7 12 7 12z" fill="#F27A54" stroke="#fff" stroke-width="1.5"/>
    <circle cx="12" cy="10" r="2.6" fill="#fff"/></svg>`,
  iconSize: [34, 34],
  iconAnchor: [17, 32],
});

function Recenter({ lat, lon }) {
  const map = useMap();
  useEffect(() => { if (lat != null && lon != null) map.setView([lat, lon], map.getZoom() < 5 ? 12 : map.getZoom()); }, [lat, lon]); // eslint-disable-line
  return null;
}

function ClickToPlace({ onMove }) {
  useMapEvents({ click(e) { onMove(e.latlng.lat, e.latlng.lng); } });
  return null;
}

export default function LocationPicker({ lat, lon, onMove }) {
  const hasPin = lat != null && lon != null;
  const center = hasPin ? [lat, lon] : [20, 0];
  return (
    <div className="h-72 w-full overflow-hidden rounded-lg border border-border" data-testid="location-picker-map">
      <MapContainer center={center} zoom={hasPin ? 12 : 2} scrollWheelZoom className="h-full w-full">
        <TileLayer attribution="&copy; OpenStreetMap contributors"
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
        <ClickToPlace onMove={onMove} />
        {hasPin && (
          <Marker position={[lat, lon]} icon={pinIcon} draggable
            eventHandlers={{ dragend: (e) => { const p = e.target.getLatLng(); onMove(p.lat, p.lng); } }} />
        )}
        {hasPin && <Recenter lat={lat} lon={lon} />}
      </MapContainer>
    </div>
  );
}
